import React from "react";
import { Link, useNavigate } from "react-router";
import notFound from "../assets/error-crying-face.svg";
import config from "../config";

export default function MatchNotFound() {
    const navigate = useNavigate();

    const handleClick = () => {
        let url = config.isWhiteLabel ? '/sport' :'/';
        navigate(url);
    };
  return (
    <div className="match-not-found">
      <h2>
        <div>
            <img src={notFound} height={'150px'} width={'150px'} style={{marginBottom:'17px'}} alt="404" />
        </div>The match you are looking for is no more live
      </h2>
      <p>Opps! Please try again later</p>
      <div className="error-404-btn">
        <button class="btn btn-primary btn-block" onClick={handleClick}>Go back to home</button>
      </div>
    </div>
  );
}
